import Vue from "vue"
import Router from "vue-router"

// Containers
const DefaultContainer = () => import("@/containers/DefaultContainer")
const BaseContainer = () => import("@/containers/BaseContainer")
// Views
const Dashboard = () => import("@/views/Dashboard")
const ArticleDetail = () => import("@/views/ArticleDetail")
//system
const UserManage = () => import("@/views/system/UserManage")
const CustmerBind = () => import("@/views/system/CustmerBind")
const DepartmentManage = () => import("@/views/system/DepartmentManage")
const PropertyManage = () => import("@/views/system/PropertyManage")
const PropertyManageTest = () => import("@/views/system/PropertyManageTest")
const RolePropertyTest = () => import("@/views/system/RolePropertyTest")
const RoleManage = () => import("@/views/system/RoleManage")
const RolePropertyManage = () => import("@/views/system/RolePropertyManage")
const LogManage = () => import("@/views/system/LogManage")
const NotifyManage = () => import("@/views/system/NotifyManage")
const SystemSetting = () => import("@/views/system/SystemSetting")
const ApproveManage = () => import("@/views/system/ApproveManage")

//base
const VendTableMain = () => import("@/views/base/VendTableMain")
const CustTableMain = () => import("@/views/base/CustTableMain")
const SaleOrderPool = () => import("@/views/base/SaleOrderPool")
const InventTableMain = () => import("@/views/base/InventTableMain")
const PriceDiscTable = () => import("@/views/base/PriceDiscTable")
const Currency = () => import("@/views/base/Currency")
const ExchRate = () => import("@/views/base/ExchRate")
const Tax = () => import("@/views/base/Tax")
const CompanyInfo = () => import("@/views/base/CompanyInfo")
const Unit = () => import("@/views/base/Unit")
const InventLocation = () => import("@/views/base/InventLocation")
const Worker = () => import("@/views/base/Worker")
const ForecastModel = () => import("@/views/base/ForecastModel")
const TECProductPartsTBL = () => import("@/views/base/TECProductPartsTBL")
const WrkCtrTable = () => import("@/views/base/WrkCtrTable")
const TECRouteTypeTBL = () => import("@/views/base/TECRouteTypeTBL")
const TECColorGroupTBL = () => import("@/views/base/TECColorGroupTBL")
const TECRouteSpoilageStdTBL = () => import("@/views/base/TECRouteSpoilageStdTBL")
const RouteOprTable = () => import("@/views/base/RouteOprTable")
const ProductPartsType = () => import("@/views/base/ProductPartsType")
const ElectricityPrices = () => import("@/views/base/ElectricityPrices")
const SpoilageTypeRatio = () => import("@/views/base/SpoilageTypeRatio")
const CostItems = () => import("@/views/base/CostItems")

//sd
const SOSalesQuote = () => import("@/views/sd/SOSalesQuote") //销售报价
const VendPurchaseQuote = () => import("@/views/sd/VendPurchaseQuote") //内部供应商采购报价
const VendPurchaseQuoteOut = () => import("@/views/sd/VendPurchaseQuoteOut") //外部供应商采购报价
const VendInitialQuote = () => import("@/views/sd/VendInitialQuote") //供应商初始报价
const SalesOrder = () => import("@/views/sd/SalesOrder") //销售订单池
const OrderForecast = () => import("@/views/sdr/OrderForecast") //销售订单池
const SOTracking = () => import("@/views/sd/SOTracking")
const SOImplementation = () => import("@/views/sd/SOImplementation")//销售订单审批执行情况
const ForecastDeliveryPlan = () => import("@/views/sdr/ForecastDeliveryPlan")
const ApprovedLog = () => import("@/views/sda/ApprovedLog")
const SaleOrderDispatch = () => import("@/views/sd/saleOrderDispatch")
const OrderForecastDispatch = () => import("@/views/sdr/OrderForecastDispatch")
const ExternalUserSetting = () => import("@/views/sd/ExternalUserSetting") //外部用户登录设置
//salesquote
const InventBom = () => import("@/views/sd/InventBom") //产品bom结构
const InventBomRoute = () => import("@/views/sd/InventBomRoute") //物料bom工艺关系
const InventBomCost = () => import("@/views/sd/InventBomCost") //物料bom成本
const InventBomVersion = () => import("@/views/sd/InventBomVersion") //产品bom结构版本
const Route = () => import("@/views/sd/Route") //工艺路线
const RouteVersion = () => import("@/views/sd/RouteVersion") //工艺路线版本
const QuotationTask = () => import("@/views/sd/QuotationTask") //报价申请
const QuotationTaskHandle = () => import("@/views/sd/QuotationTaskHandle") //报价申请处理
const QTHDistribution = () => import("@/views/sd/QTHDistribution") //主计划管理
const QTHDistributionProofing = () => import("@/views/sd/QTHDistributionProofing") //打样分配
const QuotationOrder = () => import("@/views/sd/QuotationOrder") //报价单
const QuotationOrderProofing = () => import("@/views/sd/QuotationOrderProofing") //报价单
const InventPrice = () => import("@/views/sd/InventPrice") //物料价格
const CostCacl = () => import("@/views/sd/CostCacl") //报价核算
const QuotationOrderConfirm = () => import("@/views/sd/QuotationOrderConfirm") //加权确认


//demo
const NetDemandPlan = () => import("@/views/sdr/NetDemandPlan")
const SafetyStock = () => import("@/views/sd/SafetyStock")
const SalemanForecast = () => import("@/views/sd/SalemanForecast")
//mm
const PurchaseOrder = () => import("@/views/mm/PurchaseOrder")
const DeliveryPlan = () => import("@/views/mm/DeliveryPlan")
const SaleOrderPurchaseRate = () => import("@/views/mm/saleOrderPurchaseRate")
const SupplierRate = () => import("@/views/mm/SupplierRate")
const PurchaseLineReturn = () => import("@/views/mm/PurchaseLineReturn")
const PurchImplementation = () => import("@/views/mm/PurchImplementation")
const ConsultQuote = () => import("@/views/mm/ConsultQuote")
const ConsultQuoteApplication = () => import("@/views/mm/ConsultQuoteApplication")

//fi
const CustomerCredit = () => import("@/views/fi/CustomerCredit")
const ProductionCapacity = () => import("@/views/fi/ProductionCapacity")

//wm
const InventSum = () => import("@/views/wm/InventSum")

// Views - Pages
const Page404 = () => import("@/views/pages/Page404")
const Page500 = () => import("@/views/pages/Page500")
const Login = () => import("@/views/pages/Login")
const Register = () => import("@/views/pages/Register")
const GuestLogin = () => import("@/views/pages/GuestLogin")
const Guest = () => import("@/views/pages/Guest")

const TestSalesOrder = () => import("@/views/TestSalesOrder")
const TestFieldSetting = () => import("@/views/TestFieldSetting")
const TestTable3 = () => import("@/views/TestTable3")
const ColorTest = () => import("@/views/colorTest")

Vue.use(Router)

const _router = new Router({
  mode: "history", // https://router.vuejs.org/api/#mode
  linkActiveClass: "open active",
  scrollBehavior: () => ({
    y: 0
  }),
  routes: [
    {
      path: "/",
      redirect: "/dashboard",
      name: "CPSP",
      component: DefaultContainer,
      children: [
        {
          path: "Dashboard",
          name: "Dashboard",
          component: Dashboard,
          mata: {
            title: "首页"
          },
        },
        {
          path: "ArticleDetail",
          name: "ArticleDetail",
          component: ArticleDetail,
          mata: {
            title: "资讯详情"
          }
        },
        {
          path: "system",
          redirect: "/system/UserManage",
          name: "system_setting",
          component: BaseContainer,
          children: [
            {
              path: "UserManage",
              name: "user_manage",
              component: UserManage,
              meta: {
                keepAlive: true,
                title: "用户管理"
              }
            },
            {
              path: "CustmerBind",
              name: "custmer_bind",
              component: CustmerBind,
              meta: {
                keepAlive: true,
                title: "客户绑定"
              }
            },
            // {
            //   path: "DepartmentManage",
            //   name: "部门管理",
            //   component: DepartmentManage,
            //   meta: {
            //     keepAlive: true,
            //     title: "部门管理"
            //   }
            // },
            {
              path: "PropertyManage",
              name: "privilege_manage",
              component: PropertyManage,
              meta: {
                keepAlive: true,
                title: "权限管理"
              }
            },
            {
              path: "PropertyManageTest",
              name: "privilege_manage",
              component: PropertyManageTest,
              meta: {
                keepAlive: true,
                title: "权限管理Test"
              }
            },
            {
              path: "RolePropertyTest",
              name: "privilege_manage",
              component: RolePropertyTest,
              meta: {
                keepAlive: true,
                title: "角色权限Test"
              }
            },

            {
              path: "RoleManage",
              name: "role_manage",
              component: RoleManage,
              meta: {
                keepAlive: true,
                title: "角色管理"
              }
            },
            {
              path: "RolePropertyManage",
              name: "role_privilege_setting",
              component: RolePropertyManage,
              meta: {
                keepAlive: true,
                title: "角色权限分配"
              }
            },
            {
              path: "LogManage",
              name: "log_manage",
              component: LogManage,
              meta: {
                keepAlive: true,
                title: "日志管理"
              }
            },
            {
              path: "NotifyManage",
              name: "notify",
              component: NotifyManage,
              meta: {
                keepAlive: true,
                title: "通知管理"
              }
            },
            {
              path: "ExternalUserSetting",
              name: "external_user_setting",
              component: ExternalUserSetting,
              meta: {
                keepAlive: true,
                title: "访客设置"
              }
            },
            {
              path: "ApproveManage",
              name: "ApproveManage",
              component: ApproveManage,
              meta: {
                keepAlive: true,
                title: "审批流管理"
              }
            },
            {
              path: "SystemSetting",
              name: "system_common_setting",
              component: SystemSetting,
              meta: {
                keepAlive: true,
                title: "系统设置"
              }
            }
          ]
        },
        {
          path: "base",
          redirect: "/base/VendTableMain",
          name: "base_data",
          component: BaseContainer,
          children: [
            {
              path: "VendTableMain",
              name: "VendTable",
              component: VendTableMain,
              meta: {
                keepAlive: true,
                title: "供应商档案"
              }
            },
            {
              path: "CustTableMain",
              name: "CustTable",
              component: CustTableMain,
              meta: {
                keepAlive: true,
                title: "客户档案"
              }
            },
            {
              path: "SaleOrderPool",
              name: "SalesPool",
              component: SaleOrderPool,
              meta: {
                keepAlive: true,
                title: "订单类型"
              }
            },
            {
              path: "ForecastModel",
              name: "ForecastModel",
              component: ForecastModel,
              meta: {
                keepAlive: true,
                title: "预测模型"
              }
            },
            {
              path: "InventTableMain",
              name: "InventTable",
              component: InventTableMain,
              meta: {
                keepAlive: true,
                title: "物料档案"
              }
            },
            {
              path: "PriceDiscTable",
              name: "PriceDiscTable",
              component: PriceDiscTable,
              meta: {
                keepAlive: true,
                title: "价格协议"
              }
            },
            {
              path: "Currency",
              name: "Currency",
              component: Currency,
              meta: {
                keepAlive: true,
                title: "币种档案"
              }
            },
            {
              path: "ExchRate",
              name: "ExchRate",
              component: ExchRate,
              meta: {
                keepAlive: true,
                title: "汇率档案"
              }
            },
            {
              path: "Tax",
              name: "TaxGroupHeading",
              component: Tax,
              meta: {
                keepAlive: true,
                title: "税组档案"
              }
            },
            {
              path: "CompanyInfo",
              name: "CompanyInfo",
              component: CompanyInfo,
              meta: {
                keepAlive: true,
                title: "法人档案"
              }
            },
            {
              path: "Unit",
              name: "UnitOfMeasure",
              component: Unit,
              meta: {
                keepAlive: true,
                title: "单位档案"
              }
            },
            {
              path: "InventLocation",
              name: "InventLocation",
              component: InventLocation,
              meta: {
                keepAlive: true,
                title: "仓库档案"
              }
            },
            {
              path: "Worker",
              name: "HcmWorker",
              component: Worker,
              meta: {
                keepAlive: true,
                title: "人员档案"
              }
            },
            {
              path: "ProductPartsTBL",
              name: "ProductPartsTBL",
              component: TECProductPartsTBL,
              meta: {
                keepAlive: true,
                title: "部件档案"
              }
            },
            {
              path: "WrkCtrTable",
              name: "WrkCtrTable",
              component: WrkCtrTable,
              meta: {
                keepAlive: true,
                title: "资源档案"
              }
            },
            {
              path: "TECRouteTypeTBL",
              name: "TECRouteTypeTBL",
              component: TECRouteTypeTBL,
              meta: {
                keepAlive: true,
                title: "工序类型"
              }
            },
            {
              path: "TECColorGroupTBL",
              name: "TECColorGroupTBL",
              component: TECColorGroupTBL,
              meta: {
                keepAlive: true,
                title: "色组"
              }
            },
            {
              path: "TECRouteSpoilageStdTBL",
              name: "TECRouteSpoilageStdTBL",
              component: TECRouteSpoilageStdTBL,
              meta: {
                keepAlive: true,
                title: "加放"
              }
            },
            {
              path: "RouteOprTable",
              name: "RouteOprTable",
              component: RouteOprTable,
              meta: {
                keepAlive: true,
                title: "工序档案"
              }
            },
            {
              path: "ProductPartsType",
              name: "ProductPartsType",
              component: ProductPartsType,
              meta: {
                keepAlive: true,
                title: "盒类型档案"
              }
            },
            {
              path: "ElectricityPrices",
              name: "ElectricityPrices",
              component: ElectricityPrices,
              meta: {
                keepAlive: true,
                title: "电价档案"
              }
            },
            {
              path: "CostItems",
              name: "CostItems",
              component: CostItems,
              meta: {
                keepAlive: true,
                title: "成本项档案"
              }
            },

            {
              path: "SpoilageTypeRatio",
              name: "SpoilageTypeRatio",
              component: SpoilageTypeRatio,
              meta: {
                keepAlive: true,
                title: "加放类型"
              }
            },
            {
              path: "testSO",
              name: "aaa",
              component: TestSalesOrder,
              meta: {
                keepAlive: true
              }
            }
          ]
        },
        {
          path: "sq",
          redirect: "/sq/Route",
          name: "plant_sales_quote",
          component: BaseContainer,
          children: [
            {
              path: "Route",
              name: "Route",
              component: Route,
              meta: {
                keepAlive: true,
                title: "工艺路线"
              }
            },
            {
              path: "RouteVersion",
              name: "RouteVersion",
              component: RouteVersion,
              meta: {
                keepAlive: true,
                title: "工艺路线版本"
              }
            },
            {
              path: "InventBom",
              name: "InventBom",
              component: InventBom,
              meta: {
                keepAlive: true,
                title: "物料BOM"
              }
            },
            {
              path: "InventBomVersion",
              name: "InventBomVersion",
              component: InventBomVersion,
              meta: {
                keepAlive: true,
                title: "物料BOM版本"
              }
            },
            {
              path: "InventBomRoute",
              name: "InventBomRoute",
              component: InventBomRoute,
              meta: {
                keepAlive: true,
                title: "BOM工艺关系"
              }
            },
            {
              path: "QuotationTask",
              name: "QuotationTask",
              component: QuotationTask,
              meta: {
                keepAlive: true,
                title: "报价申请"
              }
            },
            {
              path: "QuotationTaskHandle",
              name: "QuotationTaskHandle",
              component: QuotationTaskHandle,
              meta: {
                keepAlive: true,
                title: "报价申请处理"
              }
            },
            {
              path: "QTHDistribution",
              name: "QTHDistribution",
              component: QTHDistribution,
              meta: {
                keepAlive: true,
                title: "主计划管理"
              }
            },
            {
              path: "QTHDistributionProofing",
              name: "QTHDistributionProofing",
              component: QTHDistributionProofing,
              meta: {
                keepAlive: true,
                title: "打样分配"
              }
            },
            {
              path: "InventBomCost",
              name: "InventBomCost",
              component: InventBomCost,
              meta: {
                keepAlive: true,
                title: "报价试算"
              }
            },
            {
              path: "CostCacl",
              name: "CostCacl",
              component: CostCacl,
              meta: {
                keepAlive: true,
                title: "报价核算"
              }
            },
            {
              path: "QuotationOrderConfirm",
              name: "QuotationOrderConfirm",
              component: QuotationOrderConfirm,
              meta: {
                keepAlive: true,
                title: "加权成本确认"
              }
            },
            {
              path: "QuotationOrder",
              name: "QuotationOrder",
              component: QuotationOrder,
              meta: {
                keepAlive: true,
                title: "报价单"
              }
            },
            {
              path: "QuotationOrderProofing",
              name: "QuotationOrderProofing",
              component: QuotationOrderProofing,
              meta: {
                keepAlive: true,
                title: "打样报价单"
              }
            },
            {
              path: "InventPrice",
              name: "InventPrice",
              component: InventPrice,
              meta: {
                keepAlive: true,
                title: "物料价格"
              }
            },
          ]
        },
        {
          path: "sd",
          redirect: "/sd/SOSalesQuote",
          name: "sales_order_manage",
          component: BaseContainer,
          children: [
            {
              path: "SOSalesQuote",
              name: "plant_sales_quote",
              component: SOSalesQuote,
              meta: {
                keepAlive: true,
                title: ""
              }
            },
            {
              path: "VendPurchaseQuote",
              name: "vend_purchase_quote",
              component: VendPurchaseQuote,
              meta: {
                keepAlive: true,
                title: "内部供应商采购报价"
              }
            },
            {
              path: "VendPurchaseQuoteOut",
              name: "vend_purchase_quote_out",
              component: VendPurchaseQuoteOut,
              meta: {
                keepAlive: true,
                title: "外部供应商采购报价"
              }
            },
            {
              path: "VendInitialQuote",
              name: "vend_initial_quote",
              component: VendInitialQuote,
              meta: {
                keepAlive: true,
                title: "供应商初始报价"
              }
            },

            {
              path: "SalesOrder",
              name: "SalesTable",
              component: SalesOrder,
              meta: {
                keepAlive: true,
                title: "销售订单池"
              }
            },
            {
              path: "saleOrderDispatch",
              name: "sales_order_dispatch",
              component: SaleOrderDispatch,
              meta: {
                keepAlive: true,
                title: "产能分配"
              }
            },

            // {
            //   path: "ApprovedLog",
            //   name: "sales_order_approved",
            //   component: ApprovedLog,
            //   meta: {
            //     keepAlive: true,
            //     title: "订单审批记录"
            //   }
            // },
            {
              path: "SOTracking",
              name: "sales_order_tracking",
              component: SOTracking,
              meta: {
                keepAlive: true,
                title: "销售订单跟踪"
              }
            },
            {
              path: "SOImplementation",
              name: "sales_order_implementation",
              component: SOImplementation,
              meta: {
                keepAlive: true,
                title: "销售订单审批执行情况"
              }
            }
          ]
        },
        {
          path: "sda",
          redirect: "/sda/ApprovedLog",
          name: "sales_order_approved",
          component: BaseContainer,
          children: [
            {
              path: "ApprovedLog",
              name: "sales_order_approved",
              component: ApprovedLog,
              meta: {
                keepAlive: true,
                title: "订单审批记录"
              }
            }

          ]
        },
        {
          path: "sdr",
          redirect: "/sdr/sales_order_prediction",
          name: "prediction_order_manage",
          component: BaseContainer,
          children: [
            {
              path: "OrderForecast",
              name: "sales_order_prediction",
              component: OrderForecast,
              meta: {
                keepAlive: true,
                title: "预测订单"
              }
            },
            {
              path: "OrderForecastDispatch",
              name: "sales_order_prediction_dispatch",
              component: OrderForecastDispatch,
              meta: {
                keepAlive: true,
                title: "预测派发"
              }
            },
            {
              path: "ForecastDeliveryPlan",
              name: "DeliveryPlan",
              component: ForecastDeliveryPlan,
              meta: {
                keepAlive: true,
                title: "交货计划"
              }
            },
            {
              path: "NetDemandPlan",
              name: "NetDemandPlan",
              component: NetDemandPlan,
              meta: {
                keepAlive: true,
                title: "净需求分析"
              }
            }
            // {
            //   path: "SafetyStock",
            //   name: "SafetyStock",
            //   component: SafetyStock,
            //   meta: {
            //     keepAlive: true,
            //     title: "安全库存"
            //   },
            // },
            // {
            //   path: "SalemanForecast",
            //   name: "SalemanForecast",
            //   component: SalemanForecast,
            //   meta: {
            //     keepAlive: true,
            //     title: "销售员预测"
            //   },
            // }
          ]
        },
        {
          path: "mm",
          redirect: "/mm/saleOrderPurchaseRate",
          name: "purchase_order_manage",
          component: BaseContainer,
          children: [
            {
              path: "ConsultQuoteApplication",
              name: "ConsultQuoteApplication",
              component: ConsultQuoteApplication,
              meta: {
                keepAlive: true,
                title: "询价申请"
              }
            },
            {
              path: "ConsultQuote",
              name: "ConsultQuote",
              component: ConsultQuote,
              meta: {
                keepAlive: true,
                title: "询价单"
              }
            },
            {
              path: "PurchaseOrder",
              name: "PurchTable",
              component: PurchaseOrder,
              meta: {
                keepAlive: true,
                title: "采购订单池"
              }
            },
            {
              path: "PurchaseLineReturn",
              name: "PurchaseLineReturn",
              component: PurchaseLineReturn,
              meta: {
                keepAlive: true,
                title: "采购订单跟踪"
              }
            },
            {
              path: "PurchImplementation",
              name: "PurchImplementation",
              component: PurchImplementation,
              meta: {
                keepAlive: true,
                title: "采购未执行订单"
              }
            },
            {
              path: "DeliveryPlan",
              name: "DeliveryPlan",
              component: DeliveryPlan,
              meta: {
                keepAlive: true,
                title: "交货计划"
              }
            },
            {
              path: "saleOrderPurchaseRate",
              name: "purchase_order_assess",
              component: SaleOrderPurchaseRate,
              meta: {
                keepAlive: true,
                title: "采购订单评价"
              }
            },
            {
              path: "SupplierRate",
              name: "supplier_assess",
              component: SupplierRate,
              meta: {
                keepAlive: true,
                title: "供应商评价"
              }
            }
          ]
        },
        {
          path: "fi",
          component: BaseContainer,
          children: [
            {
              path: "CustomerCredit",
              name: "customer_credit_manage",
              component: CustomerCredit,
              meta: {
                keepAlive: true,
                title: "信用额度维护"
              }
            },
            {
              path: "ProductionCapacity",
              name: "production_capacity_manage",
              component: ProductionCapacity,
              meta: {
                keepAlive: true,
                title: "产能管理"
              }
            }
          ]
        },

        {
          path: "wm",
          component: BaseContainer,
          children: [
            {
              path: "InventSum",
              name: "InventSum",
              component: InventSum,
              meta: {
                keepAlive: true,
                title: "现有库存量"
              }
            }
          ]
        },
        {
          path: "test",
          component: BaseContainer,
          children: [
            {
              path: "TestFieldSetting",
              name: "测试列设置",
              component: TestFieldSetting,
              meta: {
                keepAlive: true,
                title: "测试列设置"
              }
            },
            {
              path: "TestTable3",
              name: "表格测试",
              component: TestTable3,
              meta: {
                keepAlive: true,
                title: "表格测试"
              }
            }
          ]
        },
        {
          path: "/ColorTest",
          component: ColorTest,
          children: [
            {
              path: "colorTest",
              name: "颜色配比",
              component: ColorTest,
              meta: {
                keepAlive: true,
                title: "颜色管理"
              }
            }
          ]
        }
      ]
    },
    {
      path: "/pages",
      redirect: "/pages/404",
      name: "Pages",
      component: {
        render(c) {
          return c("router-view")
        }
      },
      children: [
        {
          path: "404",
          name: "Page404",
          component: Page404,
          meta: {
            title: "404"
          }
        },
        {
          path: "500",
          name: "Page500",
          component: Page500,
          meta: {
            title: "500"
          }
        },
        {
          path: "Login",
          name: "Login",
          component: Login,
          meta: {
            title: "登录"
          }
        },
        {
          path: "register",
          name: "Register",
          component: Register,
          meta: {
            title: "注册"
          }
        },
        {
          path: "GuestLogin",
          name: "GuestLogin",
          component: GuestLogin,
          meta: {
            title: "访客登录"
          }
        },
        {
          path: "Guest",
          name: "Guest",
          component: Guest,
          meta: {
            title: "访客浏览"
          }
        }
      ]
    }
  ]
})
_router.beforeEach((to, from, next) => {
  let access_token = localStorage.getItem("access_token")
  if (
    !access_token &&
    to.path != "/pages/Login" &&
    to.path != "/pages/GuestLogin" &&
    to.path != "/pages/Guest" &&
    to.path != "/pages/Register" &&
    to.path != "/pages/page503" &&
    to.path != "/pages/page404"
  ) {
    next({
      path: "/pages/Login?url=" + encodeURIComponent(window.location.href)
    })
  } else {
    next()
  }
})
export default _router
